import { Enumify } from "enumify-ts";
class DeliveryModelType extends Enumify() {
    description;
    static LAST_MILE_DELIVERY = new DeliveryModelType("Last mile deliveries");
    static PICKUP_AND_DROP = new DeliveryModelType("Pickup and drop");
    static TRANSFER_TO_DC = new DeliveryModelType("Transfer to DC (Android only, iPhone coming soon)");
    static _ = DeliveryModelType._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
    static selectOptionsArray() {
        return DeliveryModelType.values.map(it => {
            return {
                label: it.description,
                value: it.key
            };
        });
    }
}
export default DeliveryModelType;
